import { render, staticRenderFns } from "./UploadKosiwonModal.vue?vue&type=template&id=3d0fe70f&scoped=true&"
import script from "./UploadKosiwonModal.vue?vue&type=script&lang=js&"
export * from "./UploadKosiwonModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadKosiwonModal.vue?vue&type=style&index=0&id=3d0fe70f&scoped=true&lang=less&"
import style1 from "./UploadKosiwonModal.vue?vue&type=style&index=1&id=3d0fe70f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0fe70f",
  null
  
)

export default component.exports